import { render, staticRenderFns } from "./controlCard.vue?vue&type=template&id=2b467f82&"
import script from "./controlCard.vue?vue&type=script&lang=js&"
export * from "./controlCard.vue?vue&type=script&lang=js&"
import style0 from "./controlCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "controlCard.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VCardActions } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {
  VCard,
  VCardActions,
  VCardTitle,
  VContainer,
  VLayout,
})
